/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 01/19/2016
 * Time: 5:40 PM
 *
 * A widget for creation and validation Change User Role form
 */
(function($) {
    $.widget('ca.caChangeUserRole', $.ca.caDialogForm, {
        options: {
            dialog: null,
            form: null,
            formParams: {},
            formUrl: '/layout/get-change-user-role-dialog',
            dialogOptions: {
                title: '<b>Change</b> Role'
            },
            cancelButtonId: 'cancelChangeUserRoleButton',
            submitButtonId: 'changeUserRoleButton'
        },

        _formSubmit: function () {
            var self = this;
            var formParams = self._getFormParams();
            $.caPost(
                '/user/change-group-runtime/',
                formParams,
                function (response) {
                    if (response.status == 1) {
                        window.location.href = response.url;
                    } else {
                        $.caAlert(response.message);
                    }
                }
            );
        }
    });
})(jQuery);
